export default "__VITE_ASSET__97cc037b__"